import {Calendar, DatePicker, Image, Input, Radio, Select} from 'antd'
import {baseFieldTypes} from 'apis/base/baseFieldTypes'
import classNames from 'classnames'
import {FormFieldWrapper} from 'components/form/FieldDecorator'
import {createValue} from 'components/form/utils'
import Pure from 'components/Pure'
import {FormikConsumer} from 'formik'
import {formatDate, parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import {compose, mapProps, withProps} from 'recompose'
import {withAdvancedOptions} from 'views/AppLocals/custom/AdvancedFormGroup'
import {appClassNames} from 'views/AppLocals/custom/appClassNames'
import CustomRichEditor from 'views/AppLocals/custom/CustomRichEditor'
import {PhotoUploadComposite} from 'views/AppLocals/custom/PhotoField'
import RadioOptions from 'views/AppLocals/custom/RadioOptions'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {createControlledFormField, createNumberControlledInput} from 'views/AppLocals/factory/createFormField'
import {requiredString, yupShape,} from 'views/AppLocals/factory/createValidationSchema'
import {deepTranslate, NullAsDefault, renderElse, renderIf, renderIfElse} from 'views/Shared'
import {convertFromString} from 'views/SlateEditor/functions'
import EventContext, {EventIntervalTypes, EventTypes} from '../EventContext'
import {IoCalendarOutline, IoPeople, IoPerson} from "react-icons/io5";
import {GoDotFill} from "react-icons/go";
import {getLocale} from "../../../../helpers/getLocale";
import {LocalContext} from "../../../../modules/local/LocalContext";
import dayjs from "dayjs";
import {PartialEditGroupWrapper} from "../../../../components/form/PartialEditForm";
import {shallowDiff} from "../../../Shared";
import {useEventApi} from "../functions/useEventApi";
import {getDateString} from "../../../../helpers/datetimeHelpers";
import {convertToString} from "../../../SlateEditor/functions";
import {eventModel} from "../../../../apis/model";
import {BsClockFill, BsGeoFill, BsGlobe, BsGlobeCentralSouthAsia, BsPersonCircle} from "react-icons/bs";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {PiArrowRightBold} from "react-icons/pi";
import {renderInterval, renderIntervalWeekly} from "../components/EventItem";
import {MedalSingleSelect} from "../../../Workspace/Medal/MedalSelect";
import {getId, getType} from "../../../../apis/model/base";

const formFields = [
    {name: 'title'},
    {name: 'about'},
    {name: 'medal_id'},
    // { name: 'avatar' },
    {name: 'language'},
    {name: 'schedules'},
    {name: 'time_open'},
    {name: 'time_close'},
    {name: 'event_type'},
    {name: 'description'},
    {name: 'cover_photo'},
    {name: 'location_name'},
    {name: 'external_link'},
    {name: 'interval_type'},
    {name: 'interval_daily'},
    {name: 'interval_yearly'},
    {name: 'interval_monthly'},
    // { name: 'avatar_preview' },
    {name: 'cover_photo_preview'},
    {name: 'active', defaultValue: 1},
    {name: 'status', defaultValue: 1},
    {name: 'privacy', defaultValue: 1},
    {name: 'join_policy', defaultValue: 1},
    {name: 'public', defaultValue: 1},
    {name: 'registration_enabled', defaultValue: 0},
]

const EventTypeExtra = ({values, onChange = NullAsDefault}) => {
    const t = useTranslate()
    const {event_type, external_link, location_name} = values ?? {}
    switch (event_type) {
        case EventTypes.MEETING.value:
            return (
                <Pure input={[location_name]}>
                    <FormFieldWrapper
                        label="location"
                        labelProps={{className: "flex flex-1 uppercase text-sm font-semibold text-color-300 tracking-wide mb-1"}}>
                        <Input
                            className="w-full"
                            name="location_name"
                            onChange={onChange}
                            placeholder={t('location')}
                            value={location_name}
                        />
                    </FormFieldWrapper>
                </Pure>
            )
        // case EventTypes.HYBRID.value:
        //     return (
        //         <div className="flex flex-col gap-3">
        //             <Pure input={[location_name]}>
        //                 <FormFieldWrapper
        //                     label="location"
        //                     labelProps={{className: "flex flex-1 uppercase text-sm font-semibold text-color-300 tracking-wide mb-1"}}>
        //                     <Input
        //                         className="w-full"
        //                         name="location_name"
        //                         onChange={onChange}
        //                         placeholder={t('location')}
        //                         value={location_name}
        //                     />
        //                 </FormFieldWrapper>
        //             </Pure>
        //             <Pure input={[external_link]}>
        //                 <FormFieldWrapper
        //                     label="website"
        //                     labelProps={{className: "flex flex-1 uppercase text-sm font-semibold text-color-300 tracking-wide mb-1"}}>
        //                     <Input
        //                         inputMode="url"
        //                         className="w-full"
        //                         onChange={onChange}
        //                         name="external_link"
        //                         value={values.external_link}
        //                         placeholder={t('www.yourwebsite.com...')}
        //                     />
        //                 </FormFieldWrapper>
        //             </Pure>
        //         </div>
        //     )
        case EventTypes.WEBINAR.value:
            return (
                <Pure input={[external_link]}>
                    <FormFieldWrapper
                        label="website"
                        labelProps={{className: "flex flex-1 uppercase text-sm font-semibold text-color-300 tracking-wide mb-1"}}>
                        <Input
                            inputMode="url"
                            className="w-full"
                            onChange={onChange}
                            name="external_link"
                            value={values.external_link}
                            placeholder={t('www.yourwebsite.com...')}
                        />
                    </FormFieldWrapper>
                </Pure>
            )
        // case EventTypes.REMINDER.value:
        //     return NullAsDefault
        // return (
        //     <Pure input={[external_link]}>
        //         <FormFieldWrapper label="website">
        //             <Input
        //                 inputMode="url"
        //                 className="w-full"
        //                 onChange={onChange}
        //                 name="external_link"
        //                 value={values.external_link}
        //                 placeholder={t('www.yourwebsite.com...')}
        //             />
        //         </FormFieldWrapper>
        //     </Pure>
        // )
        default:
            break
    }
    return NullAsDefault
}

const EventTypeSelect = ({name, value, onChange = NullAsDefault}) => {
    const t = useTranslate()
    return (
        <SelectWidget
            name={name}
            value={value}
            allowClear={true}
            className="w-full"
            placeholder={t('type of event')}
            onChange={(value) => {
                onChange(createValue(name, value ?? null))
            }}>
            {Object.values(EventTypes).map(({icon, label, value}) => (
                <Select.Option
                    key={value}
                    value={value}
                    label={t(label)}>
                    <div className="flex items-center gap-2">
                        {icon}
                        {t(label)}
                    </div>
                </Select.Option>
            ))}
        </SelectWidget>
    )
}

const EventSchedules = ({name, value, onChange = NullAsDefault}) => {
    const schedules = Array.from(value ?? [])
    const {lang} = useContext(LocalContext)
    return (
        <Calendar
            locale={getLocale(lang)}
            fullscreen={false}
            className="custom-calendar-picker custom-timetable-calendar"
            cellRender={(date) => (
                renderIf(
                    schedules.some((e) => date.isSame(e, 'day')),
                    <GoDotFill
                        size={15}
                        className="absolute text-blue-500"
                        style={{top: -6, right: -10}}
                    />
                )
            )}
            disabledDate={(current) => current && current < dayjs().endOf('day')}
            headerRender={({value, onChange}) => {
                const start = 0
                const end = 12
                const monthOptions = []

                const current = value.clone()
                const localeData = value.localeData()
                const months = []
                for (let i = 0; i < 12; i++) {
                    current.month(i)
                    months.push(localeData.monthsShort(current))
                }

                for (let index = start; index < end; index++) {
                    monthOptions.push(
                        <Select.Option
                            key={`${index}`}
                            className="month-item">
                            {_.capitalize(formatDate(months[index], "MMMM"))}
                        </Select.Option>
                    )
                }
                const month = formatDate(value.month(), "MMMM")

                const year = value.year()
                const options = []
                for (let i = year - 10; i < year + 10; i += 1) {
                    options.push(
                        <Select.Option
                            key={i}
                            value={i}
                            className="year-item">
                            {i}
                        </Select.Option>
                    )
                }
                return (
                    <div className="flex justify-end gap-3 p-2">
                        <SelectWidget
                            value={_.capitalize(String(month))}
                            popupMatchSelectWidth={false}
                            onChange={(selectedMonth) => {
                                const newValue = value.clone()
                                newValue.month(parseInt(selectedMonth, 10))
                                onChange(newValue)
                            }}>
                            {monthOptions}
                        </SelectWidget>
                        <SelectWidget
                            value={String(year)}
                            popupMatchSelectWidth={false}
                            onChange={(newYear) => {
                                const now = value.clone().year(newYear)
                                onChange(now)
                            }}>
                            {options}
                        </SelectWidget>
                    </div>
                )
            }}
            onSelect={(date) => {
                if (schedules.some((e) => date.isSame(e, 'day'))) {
                    const _value = schedules.filter((e) => !date.isSame(e, 'day'))
                    onChange(createValue(name, _value))
                } else {
                    const _value = [...schedules, date]
                    onChange(createValue(name, _value))
                }
            }}
        />
    )
}

const IntervalTypeSelect = ({name, value, onChange = NullAsDefault}) => {
    const t = useTranslate()
    const renderExtra = useCallback(
        (values) => {
            switch (value) {
                case EventIntervalTypes.DAILY.value:
                    const schedules = values?.schedules
                    return (
                        <React.Fragment>
                            <EventSchedules
                                name="schedules"
                                onChange={onChange}
                                value={values?.schedules}
                            />
                            {renderElse(
                                _.isEmpty(schedules),
                                <div className="space-x-1 text-sm">
                                    <div className="flex items-center gap-3">
                                        <GoDotFill size={10} className="text-color-500"/>
                                        <div className="text-color-400 italic">
                                            {`${t('The next event is scheduled in')} : `}
                                        </div>
                                    </div>
                                    <div className="font-medium text-color-000">
                                        {Array.from(schedules ?? [])
                                            .sort((a, b) => a.valueOf() - b.valueOf())
                                            .map((e) => e.format('DD/MM/YYYY'))
                                            .join(' → ')}
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )
                case EventIntervalTypes.WEEKLY.value:
                    const interval_daily = Object.assign(
                        [],
                        values?.interval_daily ?? '0000000'
                    )
                    return (
                        <div className="grid grid-cols-7 gap-1 text-xs uppercase font-bold">
                            {[
                                {value: 'M', label: 'mon'},
                                {value: 'T', label: 'tue'},
                                {value: 'W', label: 'wed'},
                                {value: 'T', label: 'thu'},
                                {value: 'F', label: 'fri'},
                                {value: 'S', label: 'sat'},
                                {value: 'S', label: 'sun'},
                            ].map(({label}, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        var _interval_daily = Object.assign([], '0000000')
                                        _interval_daily[index] = 1
                                        onChange(
                                            createValue('interval_daily', _interval_daily.join(''))
                                        )
                                    }}
                                    style={{padding: '0.65rem 0'}}
                                    className={classNames(
                                        'flex flex-center rounded-md cursor-pointer text-2xs md:text-xs cursor-pointer',
                                        !!Number(interval_daily[index])
                                            ? 'bg-primary-100 text-primary'
                                            : 'background-200 hover:bg-blue-100 hover:text-blue-700'
                                    )}>
                                    {t(label)}
                                </div>
                            ))}
                        </div>
                    )
                case EventIntervalTypes.MONTHLY.value:
                    return values?.time_open && (
                        <div className="space-x-1">
                            <GoDotFill size={10} className="text-color-500"/>
                            <span className="text-sm text-color-500 italic">
                                {t('The next event is scheduled to take place at {1}', {
                                    1: (
                                        <span className="font-medium text-color-100 222-222">
                                            {dayjs(values?.time_open).add(1, 'M').format('HH:mm - DD/MM/YYYY - UTC Z')}
                                        </span>
                                    ),
                                })}
                            </span>
                        </div>
                    )
                case EventIntervalTypes.NONE.value:
                default:
                    break
            }
            return null
        },
        [value]
    )
    return (
        <div className="space-y-3">
            <SelectWidget
                name={name}
                value={value}
                allowClear={true}
                className="w-full"
                placeholder={t('the event will repeat in')}
                onChange={(value) => {
                    onChange(createValue(name, value ?? null))
                }}>
                {[
                    EventIntervalTypes.NONE,
                    EventIntervalTypes.DAILY,
                    EventIntervalTypes.WEEKLY,
                    EventIntervalTypes.MONTHLY,
                ].map(({icon, label, value}) => (
                    <Select.Option
                        key={value}
                        value={value}
                        label={t(label)}>
                        <div className="flex items-center gap-2">
                            {icon}
                            {t(label)}
                        </div>
                    </Select.Option>
                ))}
            </SelectWidget>
            <FormikConsumer>{({values}) => renderExtra(values)}</FormikConsumer>
        </div>
    )
}


const groupFields = {
    photo: {
        title: 'photo',
        render: (item) => {

            return (
                <Translate>
                    {(t) => (
                        <div className="flex flex-col gap-1">
                            <img
                                className="w-full h-full object-cover"
                                src={`/images/default/event-bg.jpg`}
                                alt={eventModel.getTitle(
                                    item
                                )}
                            />
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                children: [
                    {
                        // name: 'avatar',
                        name: 'cover_photo',
                        component: mapProps(({form, onChange}) => ({
                            onChange,
                            renderAvatar: NullAsDefault,
                            values: form?.values,
                            fallback_cover: '/images/default/event-bg.jpg',
                            renderAvatarUploader: NullAsDefault,
                            // title: form?.values?.title,
                        }))(PhotoUploadComposite),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {
            let errors = {}

            return errors
        },
    },
    name: {
        title: 'name',
        render: (item) => {
            const {} = item ?? {}

            return (
                <Translate>
                    {t => (
                        <div className="flex flex-col gap-1">
                            <div
                                className="font-bold text-primary text-xl flex-1 inline-flex">
                                {item.title}
                            </div>
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                title: 'event name',
                children: [
                    {
                        name: 'title',
                        component: createControlledFormField({
                            maxLength: 160,
                            showCount: true,
                            placeholder: 'event name',
                            style: {borderRadius: '0.375rem'},
                        }),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            let errors = {}

            return errors
        },
    },
    about: {
        title: 'about event',
        render: (item) => {
            const {} = item ?? {}

            return (
                <Translate>
                    {t => (
                        <div className="flex flex-col gap-1">
                            {item?.description}
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                title: 'short description',
                children: [
                    {
                        name: 'description',
                        component: createControlledFormField({
                            maxLength: 500,
                            rows: 5,
                            showCount: true,
                            placeholder: 'short description',
                            Component: Input.TextArea,
                        }),
                    },
                ],
            },

            {
                title: 'about event',
                children: [
                    {
                        name: 'about',
                        component: ({name, value, form, onChange}) => {
                            const {resetKey} = form?.values ?? {}
                            return (
                                <CustomRichEditor
                                    {...{
                                        name,
                                        value,
                                        resetKey,
                                        onChange,
                                    }}
                                    placeholder="about event"
                                />
                            )
                        },
                    },
                ],
            },
        ],
        onValidate: (values, t) => {
            let errors = {}

            return errors
        },
    },
    event_type: {
        title: 'event type & schedules',
        render: (item) => {

            const {interval_type, interval_daily, event_type , time_open, time_close, external_link, location_name, schedules} = item ?? {}

            const renderLabelTime = (value) => {
                let label
                if (interval_type === 'D') {
                    label = (
                        <span className="font-medium text-color-100">
                            {schedules.sort((a, b) => a.valueOf() - b.valueOf())
                                .map((e) => formatSimplifyDate(e))
                                .join(' → ')}
                        </span>
                    )
                } else if (interval_type === 'W') {
                    label = (
                        <Translate>
                            {(t) => (
                                <span className="interval-week">
                                    {formatSimplifyDate(value, '', 'HH:mm')}
                                    {` - `}
                                    {t(renderIntervalWeekly(interval_daily))}
                                </span>
                            )}
                        </Translate>
                    )
                } else if (interval_type === 'M') {
                    label = (
                        <Translate>
                            {(t) => (
                                <span className="interval-month" >
                                    {formatSimplifyDate(value, '','HH:mm')}
                                    {` - ${t('date')} `}
                                    <span className="font-bold text-color-000">
                                        {formatSimplifyDate(value, '','DD')}
                                    </span>
                                </span>
                            )}
                        </Translate>
                    )
                } else {
                    label = formatSimplifyDate(value, 'fullTime')
                }
                return (
                    <div className="flex items-center gap-3">
                        <span className="font-semibold text-color-100">
                            {label}
                        </span>
                        {renderIf(
                            _.get(item, 'time_close'),
                            <span className="flex items-center font-semibold text-color-100">
                                <PiArrowRightBold className="mr-2 text-color-500"/>
                                {formatSimplifyDate(time_close, 'fullTime')}
                            </span>
                        )}
                        {renderIf(
                            interval_type === 'W' || interval_type === 'M',
                            <span className="ml-2 text-green-600 italic">
                                ( {renderInterval(interval_type)} )
                            </span>
                        )}
                    </div>
                )
            }

            return (
                <Translate>
                    {(t) => (
                        <div className="flex flex-col gap-2">
                            <ItemInformation
                                showIcon={true} primary={true}
                                label="type of event" value={t(event_type)}
                                className="italic"
                            />
                            <div className="flex items-center gap-2">
                                <BsClockFill size={12} className="text-color-400"/>
                                <span className="font-medium text-color-100 italic">
                                    {formatSimplifyDate(time_open, "fullTime")}
                                </span>
                                {renderIf(
                                    !!time_close,
                                    <span className="font-medium text-color-100 italic">
                                        {` \u2794  ${formatSimplifyDate(time_close, "fullTime")}`}
                                    </span>
                                )}
                            </div>
                            {renderIfElse(
                                event_type === 'webinar',
                                <div className="flex items-center gap-2">
                                    <BsGlobe size={12} className="text-color-400"/>
                                    <a
                                        target="_blank" href={_.get(item, 'external_link', '#')}
                                        className="flex-1 font-medium italic no-underline">
                                        {external_link}
                                    </a>
                                </div>
                            )}
                            {renderIf(
                                !!location_name,
                                <div className="flex items-center gap-2">
                                    <BsGeoFill size={12} className="text-color-400"/>
                                    <span className="flex-1 font-medium text-color-100 italic">
                                        {location_name}
                                    </span>
                                </div>
                            )}
                            {renderIf(
                                interval_type !== 'N',
                                <div className="flex items-center gap-2 italic">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="text-color-400 whitespace-no-wrap">
                                        {`${t('the event will repeat in')}: `}
                                    </span>
                                    <span className="font-semibold text-color-100">
                                        {renderLabelTime(time_open)}
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                inline: true,
                children: [
                    {
                        label: 'type of event',
                        name: 'event_type',
                        component: createControlledFormField({
                            Component: EventTypeSelect,
                        }),
                    },
                ],
            },
            {
                inline: true,
                className: appClassNames.inline_2,
                children: [
                    {
                        label: 'language',
                        name: 'language',
                        component: ({name, value, onChange}) => (
                            <Translate>
                                {(t) => (
                                    <SelectWidget
                                        name={name}
                                        value={value}
                                        allowClear={true}
                                        className="w-full"
                                        placeholder={t('language')}
                                        onChange={(value) => {
                                            onChange(createValue(name, value ?? null))
                                        }}
                                        options={[
                                            {label: 'vietnamese', value: 'vi'},
                                            {label: 'english', value: 'en'},
                                        ].map(deepTranslate(t))}
                                    />
                                )}
                            </Translate>
                        ),
                    },
                ],
            },
            {
                children: {
                    isInvisble: (values) => !values?.event_type,
                    component: ({form, onChange}) => (
                        <EventTypeExtra
                            onChange={onChange}
                            values={form?.values}
                        />
                    ),
                },
            },
            {
                inline: true,
                className: appClassNames.inline_2,
                title: 'time takes place',
                children: [
                    {
                        label: 'start date',
                        name: 'time_open',
                        component: ({name, value, onChange}) => (
                            <Translate>
                                {(t) => (
                                    <DatePicker
                                        showTime={true}
                                        showSecond={false}
                                        className="w-full"
                                        placeholder={t('Select date')}
                                        allowClear={false}
                                        format="DD/MM/YYYY - HH:mm"
                                        suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                        defaultValue={value ?? undefined}
                                        onChange={(value) => {
                                            onChange(createValue(name, value))
                                        }}
                                    />
                                )}
                            </Translate>
                        ),
                    },
                    {
                        label: 'end date',
                        name: 'time_close',
                        component: ({name, value, onChange}) => (
                            <Translate>
                                {(t) => (
                                    <DatePicker
                                        showTime={true}
                                        showSecond={false}
                                        className="w-full"
                                        placeholder={t('Select date')}
                                        allowClear={true}
                                        format="DD/MM/YYYY - HH:mm"
                                        suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                        defaultValue={value ?? undefined}
                                        onChange={(value) => {
                                            onChange(createValue(name, value))
                                        }}
                                    />
                                )}
                            </Translate>
                        ),
                    },
                ],
            },
            {
                // title: 'For recurring events',
                children: [
                    {
                        label: 'For recurring events',
                        name: 'interval_type',
                        component: createControlledFormField({
                            Component: IntervalTypeSelect,
                        }),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {
            let errors = {}

            return errors
        },
    },
    active: {
        title: 'status',
        render: (item) => {
            const {active, registration_enabled} = item ?? {}

            return (
                <Translate>
                    {t => (
                        <div className="flex flex-col gap-1">
                            <ItemInformation
                                showIcon={true} primary={true}
                                label="status" value={active === 1 ? t('active') : t('inactive')}
                                className="italic"
                            />
                            <ItemInformation
                                showIcon={true} primary={true}
                                label="registration enabled" value={registration_enabled === 1 ? t('yes') : t('no')}
                                className="italic"
                            />
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                inline: true,
                className: appClassNames.inline_2,
                children: [
                    {
                        label: 'registration enabled',
                        name: 'registration_enabled',
                        component: withAdvancedOptions(baseFieldTypes.yesno)(RadioOptions),
                    },
                    {
                        label: 'active',
                        name: 'active',
                        component: withAdvancedOptions(baseFieldTypes.active)(RadioOptions),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            let errors = {}

            const {} = values ?? {}

            return errors
        },
    },
    medal: {
        title: 'certification awarded',
        render: (item) => {

            return (
                <Translate>
                    {(t) => (
                        <div className="flex items-center gap-3">
                            <Image
                                preview={false}
                                style={{ width: 40 }}
                                src={item?.medal?.avatar}
                                className="rounded-md"
                                wrapperClassName="rounded-md"
                            />
                            <div className="flex flex-col gap-1">
                                {item?.medal && (
                                    <div className="font-semibold text-primary-800 tracking-wider leading-tight">
                                        {item?.medal?.title}
                                    </div>
                                )}
                                <div className="flex items-center gap-1 text-xs leading-tight">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="text-color-400 whitespace-no-wrap italic">
                                            {`${t("Certificate eligibility requirement")}: `}
                                        </span>
                                    <span className="ml-1 font-medium text-color-100">
                                            {item?.checkin_target}
                                        <span className="ml-1 font-normal whitespace-no-wrap italic">
                                                {`( ${t('check-ins')} )`}
                                            </span>
                                        </span>
                                </div>
                            </div>
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                inline: true,
                className: appClassNames.inline_1,
                children: [
                    {
                        label: 'certification awarded',
                        name: 'medal_id',
                        component: ({name, form, value, onChange}) => {
                            const defaultValue = form?.values?.medal_id
                            return (
                                <Translate>
                                    {(t) => (
                                        <EventContext.Consumer>
                                            {({event}) => (
                                                <MedalSingleSelect
                                                    {...{
                                                        name,
                                                        value,
                                                        onChange,
                                                        defaultValue,
                                                    }}
                                                    className="custom-select-medal"
                                                    placeholder={t('click to select')}
                                                    type="medal"
                                                    owner_id={getId(event?.owner)}
                                                    owner_type={getType(event?.owner)}
                                                />
                                            )}
                                        </EventContext.Consumer>
                                    )}
                                </Translate>
                            )
                        },
                    },
                    {
                        label: 'Certificate eligibility requirement',
                        name: 'checkin_target',
                        component: createNumberControlledInput({
                            placeholder: 'check-ins',
                            inputMode: 'number',
                        }),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            let errors = {}

            const {} = values ?? {}

            return errors
        },
    },
    privacy__access: {
        title: 'privacy & access',
        render: (item) => {
            return (
                <Translate>
                    {t => (
                        <div className="flex flex-col gap-1">
                            <ItemInformation
                                showIcon={true} primary={true}
                                label="privacy"
                                value={item.privacy === 1 ? t("everyone") : t("member")}
                                className="text-sm"
                            />
                            <ItemInformation
                                showIcon={true} primary={true}
                                label="general access"
                                value={item.public === 1 ? t("everyone") : t("restricted")}
                                className="text-sm"
                            />
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                title: 'privacy',
                children: [
                    {
                        name: 'privacy',
                        component: compose(
                            withProps({
                                buttonStyle: 'solid',
                                name: 'privacy',
                            })
                        )((props) => {
                            const t = useTranslate()
                            const options = [
                                {
                                    icon: <BsGlobeCentralSouthAsia size={16}/>,
                                    value: 1,
                                    label: 'public',
                                    description: 'This content is available to everyone.',
                                },
                                {
                                    icon: <BsPersonCircle size={16}/>,
                                    value: 2,
                                    label: 'private',
                                    description: 'This content is available to members only.',
                                },
                            ]
                            return (
                                <div className="flex flex-col gap-2">
                                    <Radio.Group className="custom-radio-button" {...props}>
                                        {options.map((e, i) => (
                                            <React.Fragment key={e?.value}>
                                                <Radio.Button value={e?.value}>{t(e?.label)}</Radio.Button>
                                            </React.Fragment>
                                        ))}
                                    </Radio.Group>
                                    <div className="rounded-lg">
                                        {options.map((e, i) => (
                                            <div
                                                key={i}
                                                className={classNames(
                                                    'p-2 flex flex-col gap-1',
                                                    e?.value === 1 ? 'rounded-t-lg' : 'rounded-b-lg border',
                                                    e?.value === props.value ? 'border border-primary' : 'border'
                                                )}>
                                                <div className={classNames("flex items-center gap-2", e?.value === props.value ? 'text-primary' : 'text-color-100')}>
                                                    {e?.icon}
                                                    <span className="font-bold italic tracking-wide">
                                                {t(e?.label)}
                                            </span>
                                                </div>
                                                <div
                                                    className={classNames(
                                                        'ml-6 text-sm tracking-wider leading-snug',
                                                        e?.value === props.value ? 'text-primary-500' : 'text-color-400'
                                                    )}>
                                                    {t(e?.description)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        }),
                    },
                ],
            },
            {
                title: 'general access',
                children: [
                    {
                        name: 'public',
                        component: compose(
                            withProps({
                                buttonStyle: 'solid',
                                name: 'public',
                            })
                        )((props) => {
                            const t = useTranslate()
                            const options = [
                                {
                                    icon: <IoPeople size={16}/> ,
                                    value: 1,
                                    label: 'everyone',
                                    description: 'This content is publicly visible and can appear in searches or public listings.',
                                },
                                {
                                    icon: <IoPerson size={16}/> ,
                                    value: 0,
                                    label: 'restricted',
                                    description: 'Only people with the direct link can access this content. It will not appear in searches or public listings.',
                                },
                            ]
                            return (
                                <div className="flex flex-col gap-2">
                                    <Radio.Group className="custom-radio-button" {...props}>
                                        {options.map((e, i) => (
                                            <React.Fragment key={e?.value}>
                                                <Radio.Button value={e?.value}>{t(e?.label)}</Radio.Button>
                                            </React.Fragment>
                                        ))}
                                    </Radio.Group>
                                    <div className="rounded-lg">
                                        {options.map((e, i) => (
                                            <div
                                                key={i}
                                                className={classNames(
                                                    'p-2 flex flex-col gap-1',
                                                    e?.value === 1 ? 'rounded-t-lg' : 'rounded-b-lg border',
                                                    e?.value === props.value ? 'border border-primary' : 'border'
                                                )}>
                                                <div className={classNames("flex items-center gap-2", e?.value === props.value ? 'text-primary' : 'text-color-100')}>
                                                    {e?.icon}
                                                    <span className="font-bold italic tracking-wide">
                                                {t(e?.label)}
                                            </span>
                                                </div>
                                                <div
                                                    className={classNames(
                                                        'ml-6 text-sm tracking-wider leading-snug',
                                                        e?.value === props.value ? 'text-primary-500' : 'text-color-400'
                                                    )}>
                                                    {t(e?.description)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        }),
                    },
                ],
            }
        ],
        onValidate: (values, t) => {
            let errors = {}
            const {} = values ?? {}

            return errors
        },
    },
}

const EventSettingOverview = () => {
    const t = useTranslate()
    const {event} = useContext(EventContext)

    const validationSchema = useMemo(() => {
        return yupShape({
            title: requiredString(t),
        })
    }, [t])

    const initialValues = {
        ...event,
        // avatar_preview: avatar,
        medal_id: event?.medal?.id,
        about: convertFromString(event?.about),
        cover_photo_preview: event?.cover_photo,
        interval_type: event?.interval_type ?? 'N',
        interval_monthly: event?.interval_monthly ?? 1,
        interval_daily: event?.interval_daily ?? '0000000',
        time_open: parseDayjs(event?.time_open),
        time_close: parseDayjs(event?.time_close),
        interval_yearly: event?.interval_monthly ? dayjs(event?.interval_monthly) : dayjs(),
        schedules: Array.from(event?.schedules ?? []).map((el) =>
            dayjs(el.start_time)
        ),
    }

    const {onUpdate} = useEventApi({})

    return (
        <div className="flex flex-col gap-3">
            <PartialEditGroupWrapper
                groupFields={[
                    groupFields.photo,
                    groupFields.name,
                    groupFields.about,
                    groupFields.event_type,
                    groupFields.active,
                    groupFields.privacy__access,
                    groupFields.medal,
                ]}
                initialValues={initialValues}
                item={initialValues}
                onSubmit={({ ...values }) => {
                    const {about, time_open, time_close, schedules, ...changes} = shallowDiff(values, initialValues)

                    onUpdate(
                        _.omitBy(
                            {
                                ...changes,
                                time_open: time_open ? getDateString(time_open) : undefined,
                                time_close: time_close ? getDateString(time_close) : undefined,
                                about: about ? convertToString(about) : undefined,
                                schedules: schedules ? JSON.stringify(schedules) : undefined,
                            },
                            _.isUndefined
                        ),
                        {id: event?.id}
                    )
                }}
            />
        </div>
    )
}

export default EventSettingOverview
